import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  tiendas: [],
  unidades_medidas: [],
  proveedores: [],
  productos: [],
  categorias: [],
  subcategorias: [],
  bancos: [],
  cuentas:[],
  cuentas_bancarias:[],
  posicion:[],
  clientes:[],
  pilotos: [],
  centro_costo:[],
  cuenta_contable: [],
  formas_pago: [],
  lista_precio: [],
  activos_fijos: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};